import React, { Component } from "react"
import { Router, Switch, Route } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { Redirect } from "react-router"
import { isSafari } from "helpers/util"
import { getSchoolDetailsByDomain } from "store/school/actions"

import NavigationBar from "pages/NavigationBar"
import LandingPage from "pages/LandingPage"
import MyAccount from "pages/MyAccount/index"
import CoursesPage from "pages/CoursesPage"
import CourseDetails from "pages/CourseDetailsPage"
import NotFound from "pages/NotFound"
import ScrollToTop from "components/common/ScrollToTop"
import LearningModule from "pages/LearningModule/index"
import CourseBundlesPage from "pages/CourseBundles/index"
import CourseBundleDetails from "pages/CourseBundles/BundleDetails"
import Forums from "pages/Forums/"
import Topic from "pages/Forums/Topic"
import ForumSearch from "pages/Forums/Search"
import history from "app/history"
import CoursePayment from "pages/Payment"
import BundlePayment from "pages/Payment/BundlePayment"
import FAQPage from "pages/Custom/FAQs"
import ProtectedRoute from "components/protected-route"
import AuthPage from "pages/AuthPage"
import InfoPage from "pages/InfoPage"
import PaymentResultPage from "pages/PaymentResultPage"

// Import styles
import "./css/general.scss"
import "./css/reset.scss"
import "./css/variables.scss"
import "./css/icons.scss"
import "./css/animations.scss"
import "react-toastify/dist/ReactToastify.min.css"
import InstructionPage from "pages/Payment/InstructionPage"

class App extends Component {
  render() {
    const { auth } = this.props
    return (
      <Router history={history}>
        <ScrollToTop />
        <ToastContainer
          position="top-center"
          autoClose={3000}
          hideProgressBar={true}
          limit={1}
          toastClassName="custom-toast"
          bodyClassName="toast-body"
          closeOnClick
          pauseOnFocusLoss
          pauseOnHover
        />
        <Switch>
          <Route path={"/course/:slug/module/:id"} component={LearningModule} />
          <Route exact path={"/error-404"} component={NotFound} />
          <Route exact path={"/info-page"} component={InfoPage} />
          {isSafari() && <Redirect to="/info-page" />}
          <Route>
            <NavigationBar />
            <Switch>
              <Route exact path={"/"} component={LandingPage} />
              <Route
                exact
                path={"/reset_password/:reset_token"}
                component={LandingPage}
              />
              <Route
                exact
                path={"/student/verified/"}
                component={LandingPage}
              />
              <ProtectedRoute
                exact
                isPermitted={auth?.isAuthorized}
                path={"/student/profile"}
                component={MyAccount}
              />
              <ProtectedRoute
                exact
                isPermitted={auth?.isAuthorized}
                path={"/student/:tabs"}
                component={MyAccount}
              />
              <Route exact path={"/courses"} component={CoursesPage} />
              <Route exact path={"/course/:slug"} component={CourseDetails} />
              <Route
                exact
                path={"/course-bundles"}
                component={CourseBundlesPage}
              />
              <Route
                exact
                path={"/course-bundle/:id"}
                component={CourseBundleDetails}
              />
              <Route exact path={"/forums"} component={Forums} />
              <Route exact path={"/forums/topic/:id"} component={Topic} />
              <Route exact path={"/forums/search"} component={ForumSearch} />
              <ProtectedRoute
                exact
                isPermitted={auth?.isAuthorized}
                path={"/course/payment/:slug"}
                component={CoursePayment}
              />
              <ProtectedRoute
                exact
                isPermitted={auth?.isAuthorized}
                path={"/course/payment/:id/instruction"}
                component={InstructionPage}
              />
              <ProtectedRoute
                exact
                isPermitted={auth?.isAuthorized}
                path={"/course-bundle/payment/:slug"}
                component={BundlePayment}
              />
              <ProtectedRoute
                exact
                isPermitted={auth?.isAuthorized}
                path={"/enrollment/payment"}
                component={PaymentResultPage}
              />
              <Route exact path={"/faqs"} component={FAQPage} />
              <Route exact path={"/auth/:token"} component={AuthPage} />
              <Route component={NotFound} />
            </Switch>
          </Route>
        </Switch>
      </Router>
    )
  }
}

const mapStateToProps = (state) => ({
  school: state.schoolReducer,
  landing: state.landingReducer,
  auth: state.authReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ getSchoolDetailsByDomain }, dispatch)

export default compose(connect(mapStateToProps, mapDispatchToProps))(App)
